import registrationInstance from '../instance'

const getChangeSettings = (module) => {
  return registrationInstance.get(`/company/changeSettings/${module}`)
}

export default getChangeSettings
